import { render, staticRenderFns } from "./cart_component.vue?vue&type=template&id=88e0b1c4&scoped=true&"
import script from "../../assets/customer/js/cart.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/cart.js?vue&type=script&lang=js&"
import style0 from "./cart_component.vue?vue&type=style&index=0&id=88e0b1c4&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e0b1c4",
  null
  
)

export default component.exports